import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// Core
import { CoreModule } from './core/core.module';

// Feature Modules
import { UiModule } from './ui/shared/ui.module';

// MDB Imports
import { MDBSpinningPreloader } from 'ng-uikit-pro-standard';
import { NO_ERRORS_SCHEMA } from '@angular/core';
import { AgmCoreModule } from '@agm/core';
import { ToastModule } from 'ng-uikit-pro-standard';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
// End MDB Imports

import { environment } from '../environments/environment';
import { AngularFireModule } from '@angular/fire';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import 'firebase/auth';
import 'firebase/firestore';
import { AngularFireAnalyticsModule } from "@angular/fire/analytics";
//import { AngularFireStorageModule } from '@angular/fire/storage';
/*import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireFunctionsModule } from '@angular/fire/functions';
import { AngularFirePerformanceModule } from '@angular/fire/performance';*/
export const firebaseConfig = environment.firebaseConfig;
export const firebaseConfigSecondary = environment.firebaseConfigSecondary;
export const googleAPIKey = environment.googleAPIKey;
//import { AngularFirestoreModule } from '@angular/fire/firestore';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BlastFurnaceAdminComponent } from './blast-furnace-admin/blast-furnace-admin.component';
import { BlastFurnaceLeaderboardComponent } from './blast-furnace-leaderboard/blast-furnace-leaderboard.component';
import { BlastFurnaceEventComponent } from './blast-furnace-event/blast-furnace-event.component';
import { BlastFurnaceCompHistoryComponent } from './blast-furnace/blast-furnace-comp-history/blast-furnace-comp-history.component';
import { BlastFurnaceLessonsComponent } from './blast-furnace-lessons/blast-furnace-lessons.component';

//CHARTS
import { BlastFurnaceComponent } from './blast-furnace/blast-furnace.component';

//Date Picker
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
//import {MatButtonModule, MatCheckboxModule, MatNativeDateModule,   } from '@angular/material'; // MatInputModule, MatAutocompleteModule, MatFormFieldModule,
import {MatDatepickerModule} from '@angular/material/datepicker';
import { TopNavComingSoonComponent } from './coming-soon/top-nav-coming-soon/top-nav-coming-soon.component';
import { FooterNavComingSoonComponent } from './coming-soon/footer-nav-coming-soon/footer-nav-coming-soon.component';
import { HomeComingSoonComponent } from './coming-soon/home-coming-soon/home-coming-soon.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { PromptComponent } from './prompt-component/prompt-component.component';
import { PwaService } from './core/pwa-service.service';

const initializer = (pwaService: PwaService) => () => pwaService.initPwaPrompt();
@NgModule({
  declarations: [
    AppComponent,
    BlastFurnaceAdminComponent,
    BlastFurnaceLeaderboardComponent,
    BlastFurnaceEventComponent,
    BlastFurnaceComponent,
    TopNavComingSoonComponent,
    FooterNavComingSoonComponent,
    HomeComingSoonComponent,
    BlastFurnaceCompHistoryComponent,
    BlastFurnaceLessonsComponent,
    PromptComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    AppRoutingModule,
    CoreModule,
    UiModule,
    AngularFireModule.initializeApp(firebaseConfigSecondary),
    AngularFireMessagingModule,
    AngularFireAnalyticsModule,
    MDBBootstrapModulesPro.forRoot(),
    AgmCoreModule.forRoot({ apiKey: googleAPIKey, libraries: ["places"] }),
    ToastModule.forRoot(),
    BrowserAnimationsModule,
    MatBottomSheetModule,
    MatToolbarModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    FormsModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production, registrationStrategy: 'registerImmediately' }),
  ],
  entryComponents: [
    PromptComponent,
  ],
  providers: [{provide: APP_INITIALIZER, useFactory: initializer, deps: [PwaService], multi: true}, MDBSpinningPreloader],
  bootstrap: [AppComponent],
  schemas: [ NO_ERRORS_SCHEMA ]
})
export class AppModule { }
